<template>
	<div class="padding-tb-sm" v-loading="loading">
	<div style="height: 400px; overflow: auto;">
			<el-tree
				ref="tree"
				:data="treeData"
				:expand-on-click-node="false"
				:props="{ label: 'name' }"
				:default-checked-keys="selected"
				default-expand-all
				highlight-current
				node-key="id"
				check-strictly
				:indent="0"
				show-checkbox
				check-on-click-node
				class="tree-line"
				@check-change="checkChange"
			></el-tree>
	</div>
		
	</div>
</template>

<script>
export default {
	name: 'department-select',
	props: {
		visible:{
			type:Boolean,
			default:()=>{
				return false;
			}
		},
		current: {
			type: Array,
			default: () => {
				return [];
			}
		},
		config: {
			type: Object,
			default: () => {
				return { props: { label: 'name' }, key: 'id' };
			}
		}
	},
	data() {
		return {
			cfg: {},
			cVisible:false,
			loading: true,
			treeData: [],
			selected:[],
			errorMsg: ''
		};
	},
	created: function() {
	},
	mounted() {
		this.cfg = this.config;
		this.cVisible = this.visible;
		this.selected = this.current;
		this.init();
	},
	methods: {
		init(){
			if(this.cVisible){
				if(this.treeData.length<1){
					this.getDepartmentTreeData();
				}
				else{
					this.loading = false;
				}
			}
		},
		getDepartmentTreeData(){
			this.loading = true;
			this.$http.post('/server/index.php?m=hr/department&a=getDepartmentTreeData', {}).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.treeData = res.data;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		checkChange(d,e,f) {
			this.selected=this.$refs["tree"].getCheckedKeys();
			let dataList=[];
			for(let i=0;i<this.selected.length;i++){
				let node=this.$refs["tree"].getNode(this.selected[i]);
				let data=Object.assign({},node.data);
				data.path=[];
				data.pathName=[];
				while(node.parent!=null){
					data.path.push(node.data.id);
					data.pathName.push(node.data.name);
					node=Object.assign({},node.parent);
				}
				data.path.reverse();
				data.pathName.reverse();
				dataList.push(data);
			}
			
			this.$emit('change', this.selected,dataList);
		}
	},
	watch: {
		visible: function(d) {
			this.cVisible = d;
			this.init();
		}
	}
};
</script>

<style>
	.el-popover{
		padding: 0;
	}
	.el-popover__title{
		padding: 10px 15px;
		margin-bottom: 0;
		border-bottom: #eee 1px solid;
	}
.tree-line .el-tree-node {
	position: relative;
	padding-left: 10px;
}
.tree-line .el-tree-node__children {
	padding-left: 10px;
}
.tree-line .el-tree-node::before {
	content: '';
	height: 100%;
	width: 1px;
	position: absolute;
	left: -3px;
	top: -26px;
	border-width: 1px;
	border-left: 1px dashed #ddd;
}
.tree-line .el-tree-node:last-child::before {
	height: 38px;
}
.tree-line .el-tree-node::after {
	content: '';
	width: 24px;
	height: 20px;
	position: absolute;
	left: -3px;
	top: 12px;
	border-width: 1px;
	border-top: 1px dashed #ddd;
}
.tree-line > .el-tree-node::after {
	border-top: none;
}
.tree-line > .el-tree-node::before {
	border-left: none;
}
.tree-line .el-tree-node__expand-icon {
	font-size: 10px;
}
.tree-line .el-tree-node__expand-icon.is-leaf {
	color: transparent;
}
.tree-menu.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
	background-color: #515a6e;
	color: #fff;
}
</style>
